<template>
  <transition-group v-if="totalItems > 1" tag="div" name="dot-slide" class="pagination-dots">
    <div
      v-for="dot in visibleDots"
      :key="dot.index"
      :class="['dot', { active: dot.index === currentIndex, smaller: dot.smaller }]"
    ></div>
  </transition-group>
</template>

<script>
export default {
  name: 'PaginationDots',
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    currentIndex: {
      type: Number,
      required: true
    },
    maxDots: {
      type: Number,
      default: 5
    }
  },
  computed: {
    visibleDots() {
      const totalDots = this.totalItems;
      const halfWindow = Math.floor(this.maxDots / 2);

      if (totalDots <= this.maxDots) {
        return Array.from({ length: totalDots }, (_, i) => ({ index: i, smaller: false }));
      }

      let start = Math.max(0, this.currentIndex - halfWindow);
      let end = start + this.maxDots;

      // Adjust the window if it exceeds the total dots
      if (end > totalDots) {
        end = totalDots;
        start = totalDots - this.maxDots;
      }

      return Array.from({ length: end - start }, (_, i) => {
        const index = start + i;
        return {
          index,
          smaller: (index === start && start > 0) || (index === end - 1 && end < totalDots)
        };
      });
    },
  }
};
</script>

<style scoped>
.pagination-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--background-color-alt6);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.dot.active {
  background-color: #4A3F6B;
}

.dot.smaller {
  transform: scale(0.7);
}

.dot-slide-move {
  transition: transform 0.25s ease;
}

.dot-slide-enter-active,
.dot-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.dot-slide-enter-from,
.dot-slide-leave-to {
  opacity: 0;
  transform: scale(0.3);
}

.dot-slide-leave-active {
  position: absolute;
}
</style>
